module.exports = __webpack_public_path__ + "static/product-f596061279312ab7c15a3e6d0f4ca7cd.png";